import * as yup from 'yup'

const defaultProperties = yup.object({
	isHidden: yup.boolean().meta({ description: 'sets visibility:hidden to the component style node' }).notRequired(),
	isCollapsed: yup.boolean().meta({ description: 'sets isCollapsed for component' }).notRequired(),
})

const disableableProperties = yup.object({
	isDisabled: yup.boolean().meta({ description: 'disables the component' }).default(false),
})

export { defaultProperties, disableableProperties }
